module.exports = __webpack_public_path__ + "img/or.338b2c97.png";